<template>
  <div
    ref="headerRef"
    class="headerBackground mb-2"
    :class="{
      'header-sticky': isSticky && !props.homeMode,
      'header-home': props.homeMode,
      'header-home--visible': props.homeMode && isSticky,
    }"
  >
    <div class="container fluid movil-container">
      <div class="row leagueHeader">
        <transition name="mobile-search-expand">
          <div
            v-if="isMobile && showSearchPopup && !props.homeMode"
            class="mobile-search-bar"
            @click.stop
          >
            <font-awesome-icon
              :icon="faMagnifyingGlass"
              class="mobile-search-bar__icon"
            />
            <input
              ref="searchInputRef"
              v-model="search"
              type="text"
              class="mobile-search-bar__input"
              placeholder="Search..."
              @keyup.enter="emitSearch"
              @keyup.esc="closeMobileSearch"
              @blur="closeMobileSearch"
            />
          </div>
        </transition>
        <div
          ref="leagueScroller"
          class="row col-9 col-md-5 col-lg-10 overflow-length"
          :class="{
            'overflow-length--search-open': isMobile && showSearchPopup,
            'overflow-length--fade-start': showStartFade,
            'overflow-length--fade-end': showEndFade,
          }"
          @scroll="updateScrollFades"
        >
          <template v-if="!isSticky && !props.homeMode">
            <div
              v-if="selectedSport === 'props'"
              class="row mx-0 col header-width"
            >
              <div v-for="filter in propsFilters" :key="filter.key">
                <button
                  class="indicationBets indicationBets-fourcaster mr-2"
                  :class="{ 'router-link-active': filter.key === activePropsFilter }"
                  style="width: max-content"
                  @click="emitPropsFilter(filter.key)"
                >
                  {{ filter.label }}
                </button>
              </div>
              <div>
                <button
                  class="indicationBets indicationBets-create mr-2"
                  style="width: max-content"
                  @click="openModal('')"
                >
                  CREATE
                </button>
              </div>
            </div>
            <div
              v-else-if="!['fighting', 'custom', 'soccer'].includes(selectedSport)"
              class="row mx-0 col header-width"
            >
              <div v-for="league in filteredLeagues" :key="league">
                <RouterLink
                  v-slot="{ navigate, isActive }"
                  :to="{
                    name: routeName,
                    params: {
                      sport: selectedSport,
                      league: league.toString().toLowerCase(),
                    },
                  }"
                  custom
                >
                  <button
                    :class="{ 'router-link-active': isActive }"
                    class="indicationBets indicationBets-fourcaster mr-2"
                    style="width: max-content"
                    @click="navigate"
                  >
                    {{
                      formatGolfLeagueName(
                        convert1H(
                          hyphenateUrlParams(league.toString()).toUpperCase(),
                        ),
                        selectedSport,
                      )
                    }}
                  </button>
                </RouterLink>
              </div>
              <div>
                <button
                  class="indicationBets indicationBets-create mr-2"
                  style="width: max-content"
                  @click="openModal(selectedSport)"
                >
                  CREATE
                </button>
              </div>
            </div>
            <div
              v-else-if="sport == 'fighting'"
              class="row header-width mx-0"
            >
              <div
                v-for="league in filteredLeagues"
                :key="league"
                class="button"
              >
                <RouterLink
                  v-slot="{ navigate, isActive }"
                  :to="{
                    name: routeName,
                    params: {
                      sport: selectedSport,
                      league:
                        league.toString().toLowerCase() !== 'ufcmma'
                          ? league.toString().toLowerCase()
                          : 'ufc',
                    },
                  }"
                  exact-active-class="router-link-active"
                  custom
                >
                  <button
                    :class="{ 'router-link-active': isActive }"
                    class="indicationBets indicationBets-fourcaster mr-2"
                    style="width: max-content"
                    @click="navigate"
                  >
                    {{
                      convert1H(
                        hyphenateUrlParams(league.toString()).toUpperCase(),
                      ) !== 'UFCMMA'
                        ? convert1H(
                            hyphenateUrlParams(league.toString()).toUpperCase(),
                          )
                        : 'UFC'
                    }}
                  </button>
                </RouterLink>
              </div>
              <div>
                <button
                  class="indicationBets indicationBets-create mr-2"
                  style="width: max-content"
                  @click="openModal('fighting')"
                >
                  CREATE
                </button>
              </div>
            </div>
            <div
              v-else-if="sport == 'custom'"
              class="row custom-header"
              style="margin: 0"
            >
              <div class="createGameDiv">
                <button class="createGame" @click="openModal()">
                  CREATE NEW MARKET
                </button>
              </div>
            </div>
            <div
              v-else-if="selectedSport === 'soccer'"
              class="row col-1 header-width mx-0"
            >
              <!-- All button -->
              <div>
                <RouterLink
                  v-slot="{ navigate, isActive }"
                  :to="{
                    name: routeName,
                    params: {
                      sport: selectedSport,
                      league: 'all',
                    },
                  }"
                  custom
                >
                  <button
                    :class="{ 'router-link-active': isActive }"
                    class="indicationBets indicationBets-fourcaster mr-2"
                    style="width: max-content"
                    @click="navigate"
                  >
                    ALL
                  </button>
                </RouterLink>
              </div>
              <!-- Featured button -->
              <div>
                <RouterLink
                  v-slot="{ navigate, isActive }"
                  :to="{
                    name: routeName,
                    params: {
                      sport: selectedSport,
                      league: 'featured-soccer',
                    },
                  }"
                  custom
                >
                  <button
                    :class="{ 'router-link-active': isActive }"
                    class="indicationBets indicationBets-fourcaster mr-2"
                    style="width: max-content"
                    @click="navigate"
                  >
                    FEATURED
                  </button>
                </RouterLink>
              </div>
              <!-- Continent buttons -->
              <div v-for="continent in availableContinents" :key="continent">
                <template v-if="continent.toString().toLowerCase() !== 'all'">
                    <button
                      class="indicationBets indicationBets-fourcaster mr-2"
                      style="width: max-content"
                      @click="openContinentMenu(continent)"
                    >
                      {{
                        convert1H(
                          hyphenateUrlParams(continent.toString()).toUpperCase(),
                        )
                      }}
                    </button>
                </template>
                <template v-else>
                  <div class="leagues-menu-wrapper mr-2">
                    <div
                      ref="leaguesMenuButtonRef"
                      class="leagues-menu"
                      @click.stop="toggleLeaguesMenu"
                    >
                      <font-awesome-icon :icon="faChevronDown" class="mr-2" />
                      {{
                        convert1H(
                          hyphenateUrlParams(continent.toString()).toUpperCase(),
                        )
                      }}
                    </div>
                  </div>
                </template>
              </div>
              <div>
                <button
                  class="indicationBets indicationBets-create mr-2"
                  style="width: max-content"
                  @click="openModal('soccer')"
                >
                  CREATE
                </button>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              ref="stickyNavScroller"
              class="sticky-nav-scroller"
              @scroll="updateScrollFades"
            >
              <RouterLink
                v-for="sport in filteredSports"
                :key="sport.id"
                :to="sport.link"
                v-slot="{ navigate, isActive }"
                custom
              >
                <button
                  class="sticky-sport-btn"
                  :class="{ active: isSportActive(sport) }"
                  :disabled="sport.disabled"
                  @click="handleSportNavigate(sport, navigate, $event)"
                >
                  <span class="sticky-sport-icon">
                    <font-awesome-icon
                      :icon="getFaSportIcon(sport)"
                      class="sticky-sport-icon__glyph"
                      :flip="sport.sport === 'fighting' ? 'horizontal' : null"
                    />
                  </span>
                  <span class="sticky-sport-text">{{ sport.name }}</span>
                </button>
              </RouterLink>
            </div>
          </template>
        </div>
        <div
          v-if="leaguesMenu && !isSticky && selectedSport === 'soccer'"
          class="leagues-popup py-0"
          :style="popupStyle"
          @click.stop="leaguesMenu = !leaguesMenu"
        >
          <div class="row mx-0 my-2">
            <div
              v-for="league in sortedLeagues"
              :key="league"
              class="col-sm-4 col-md-3 col-12 align-self-center px-0"
            >
              <router-link
                v-slot="{ navigate, isActive }"
                :to="
                  routeName.toLowerCase() === 'exchange'
                    ? `/exchange/${selectedSport}/${league.toString().toLowerCase()}`
                    : `/${selectedSport}/${league.toString().toLowerCase()}`
                "
                custom
              >
                <button
                  class="leagues-menu-item px-0"
                  :class="{
                    'font-weight-bold':
                      league.toString().toLowerCase() === selectedLeague,
                    'router-link-active': isActive,
                  }"
                  @click="navigate"
                >
                  {{
                    convert1H(
                      hyphenateUrlParams(league.toString()).toUpperCase(),
                    )
                  }}
                </button>
              </router-link>
            </div>
          </div>
        </div>
        <div
          class="d-flex col-3 col-md-5 col-lg-2 mini"
          :class="{ 'mini--search-open': isMobile && showSearchPopup }"
        >
          <div
            class="d-flex align-items-center align-content-center content-account-info"
            style="margin-left: auto; cursor: pointer"
          >
            <notification-bell
              ref="notificationBellRef"
              :has-unread="unreadCount > 0"
              variant="header"
              @click="handleNotificationBellClick"
            />
            <div
              v-if="!isMobile"
              class="notification-search-trigger"
              :class="{
                'notification-search-trigger--active': showSearchPopup,
              }"
              @click.stop="toggleSearchPopup"
            >
              <font-awesome-icon
                :style="{
                  visibility:
                    showSearchPopup && !props.homeMode ? 'hidden' : 'visible',
                }"
                :icon="faMagnifyingGlass"
                class="notification-search-trigger__icon"
              />
              <!-- Homepage keeps the drop-down search; sport pages get the
                   4cx-style pill that slides out leftward from the magnifier. -->
              <transition name="fade">
                <div
                  v-if="showSearchPopup && props.homeMode"
                  class="notification-search"
                  @click.stop
                >
                  <input
                    ref="searchInputRef"
                    v-model="search"
                    type="text"
                    class="notification-search__input"
                    placeholder="Search Games"
                    @keyup.enter="emitSearch"
                  />
                </div>
              </transition>
              <transition name="league-search-expand">
                <div
                  v-if="showSearchPopup && !props.homeMode"
                  class="league-search-pullout"
                  @click.stop
                >
                  <font-awesome-icon
                    :icon="faMagnifyingGlass"
                    class="league-search-pullout__icon"
                  />
                  <input
                    ref="searchInputRef"
                    v-model="search"
                    type="text"
                    class="league-search-pullout__input"
                    placeholder="Search..."
                    @keyup.enter="emitSearch"
                    @keyup.esc="showSearchPopup = false"
                  />
                </div>
              </transition>
            </div>
            <div class="account-logo ml-lg-3 d-flex flex-nowrap">
              <font-awesome-icon
                :icon="faSliders"
                class="font-weight-light filter-icon"
                :class="{ 'filter-icon--active': userSettingPopUp }"
                @click.stop="
                  ((userSettingPopUp = !userSettingPopUp),
                  (accountPopUp = false),
                  (showSearchPopup = false))
                "
              />
            </div>
          </div>
          <div
            v-show="userSettingPopUp && !accountPopUp"
            class="popup py-0"
            @click.stop
          >
            <user-preferences-menu
              @close="userSettingPopUp = false"
              @cancel-all="cancelAll"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container sub-league-container">
      <div v-if="isOpenContinentMenu" class="soccer-leagues-dropdown">
        <div class="soccer-leagues-header d-md-none">
          <span class="soccer-leagues-title">{{ selectedContinent }} Leagues</span>
          <button class="soccer-leagues-close" @click="isOpenContinentMenu = false">
            <font-awesome-icon :icon="faXmark" />
          </button>
        </div>
        <div class="soccer-leagues-grid">
          <RouterLink
            v-for="league in filteredLeaguesBySelectedContinent"
            :key="league.code"
            :to="
                routeName.toLowerCase() === 'exchange'
                  ? `/exchange/${selectedSport}/${league.code.toLowerCase()}`
                  : `/${selectedSport}/${league.code.toString().toLowerCase()}`
                  "
                v-slot="{ navigate, isActive }"
                custom
              >
              <a
                class="soccer-league-item"
                :class="{ 'soccer-league-item--active': isActive }"
                @click="navigate(); isOpenContinentMenu = false"
              >
                <span class="soccer-league-flag">{{ getCountryFlag(league.country, league.name) }}</span>
                <span class="soccer-league-name">{{ league.name }}</span>
              </a>
            </RouterLink>
        </div>
      </div>
    </div>
    <Teleport to="body">
      <createGame v-if="showCreateGame" :initial-sport="createGameSport" @close-modal="showCreateGame = false" />
    </Teleport>
  </div>
</template>

<script setup>
import Swal from 'sweetalert2';
import { ref, computed, onMounted, onBeforeUnmount, nextTick, watch } from 'vue';
import { useWindowSize } from '@/composables/useWindowSize';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useExchangeStore } from '@/stores/exchange';
import { useMiscStore } from '@/stores/store';
import { useNotificationStore } from '@/stores/notification';
import { useUserStore } from '@/stores/user';
import { useAPI } from '@/composables/useAPI';
import { emitter } from '../../../core/emitter';
import {
  mobileSearchRequest,
  consumeMobileSearch,
  setMobileSearchOpen,
} from '@/core/mobileSearch';
import { soccerLeagues } from '../../../consts/constants';
import { checkAuthAndShowLogin } from '@/core/authUtils';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSliders } from '@fortawesome/pro-regular-svg-icons/faSliders';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlass';
import NotificationBell from '@/components/global/header/NotificationBell.vue';
import UserPreferencesMenu from '@/components/global/header/UserPreferencesMenu.vue';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import createGame from '@/components/betting/modals/CreateGameModal.vue';
import { getFaSportIcon } from '@/core/getIcon.js';
import {
  allPropsRouteNames,
  adjustLinksForExchange,
  baseSports,
  filterAvailableSports,
} from '@/core/sportsNav.js';

const { width } = useWindowSize();
const isMobile = computed(() => {
  return width.value <= 576;
});
const exchangeStore = useExchangeStore();
const userStore = useUserStore();
const miscStore = useMiscStore();
const notificationStore = useNotificationStore();
const route = useRoute();
const router = useRouter();

const { leagues, games } = storeToRefs(exchangeStore);
const { numUnread } = storeToRefs(notificationStore);

const search = ref('');
const leaguesMenu = ref(false);
const showCreateGame = ref(false);
const loading = ref(false);
const showSearchPopup = ref(false);
const searchInputRef = ref(null);
const headerRef = ref(null);
const isSticky = ref(false);
const stickyOffset = ref(0);
const notificationBellRef = ref(null);
const leaguesMenuButtonRef = ref(null);
const popupPosition = ref({ top: 0, left: 0 });
const isOpenContinentMenu = ref(false);

// Horizontal scroll affordance for the league/nav row. When there's more
// content than fits, the overflowing edge fades out over the header
// background so the strip reads as scrollable instead of hard-cut against
// the bell/filter icons.
const leagueScroller = ref(null);
const stickyNavScroller = ref(null);
const showStartFade = ref(false);
const showEndFade = ref(false);

function updateScrollFades() {
  // In sticky/home mode the nested sport strip is the element that actually
  // scrolls — the outer .overflow-length only ever overflows in the normal
  // league-tab row (and scroll events don't bubble up from the strip).
  const el = stickyNavScroller.value ?? leagueScroller.value;
  if (!el) {
    showStartFade.value = false;
    showEndFade.value = false;
    return;
  }
  const maxScroll = el.scrollWidth - el.clientWidth;
  // 4px tolerance so subpixel rounding at the ends doesn't leave a fade lit.
  showStartFade.value = el.scrollLeft > 4;
  showEndFade.value = el.scrollLeft < maxScroll - 4;
}

const props = defineProps({
  selectedSport: {
    type: String,
    required: true,
    default: String,
  },
  selectedLeague: {
    type: String,
    required: true,
    default: String,
  },
  sport: {
    type: String,
    required: false,
    default: String,
  },
  propsFilters: {
    type: Array,
    required: false,
    default: () => [],
  },
  activePropsFilter: {
    type: String,
    required: false,
    default: '',
  },
  homeMode: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(['searchForEvent', 'refreshData', 'selectPropsFilter']);

function emitPropsFilter(key) {
  emit('selectPropsFilter', key);
}

const userSettingPopUp = ref(false);

const selectedContinent = ref('');

const filteredSports = computed(() => {
  const adjusted = userStore.user.sportsbookDefault
    ? baseSports
    : baseSports.map(adjustLinksForExchange);

  return filterAvailableSports(
    adjusted,
    exchangeStore.sportsNavigations.sportsAvailable,
    { excludeCustom: true },
  );
});

const filteredLeaguesBySelectedContinent = computed(() => {
  return leaguesGroupedByContinent.value[selectedContinent.value];
});

const createGameSport = ref('');

function openModal(sport = '') {
  createGameSport.value = sport;
  showCreateGame.value = true;
}

function sortLeaguesWithPinned(list) {
  const pinnedOrder = ['CUSTOM', 'CFL', 'UFL'];
  const core = [];
  const pinned = [];

  list.forEach((league) => {
    const upper = league?.toString().toUpperCase();
    if (upper && pinnedOrder.includes(upper)) {
      pinned.push(league);
    } else {
      core.push(league);
    }
  });

  core.sort();

  return [...core, ...pinned];
}

const BASE_TOKEN_OVERRIDES = {
  HEISMAN: 'NCAAF',
};

function getPrimaryToken(label) {
  if (!label) return '';
  const cleaned = label.replace(/[()]/g, ' ').trim();
  if (!cleaned) return '';
  const parts = cleaned.split(/[\s/-]+/).filter(Boolean);
  if (!parts.length) return '';

  const first = parts[0];
  if (['1H', '2H', 'F5', 'Q1', 'Q2', 'Q3', 'Q4'].includes(first) && parts[1]) {
    return parts[1];
  }
  return first;
}

function mapBaseToken(token) {
  if (!token) return '';
  const upper = token.toUpperCase();
  return BASE_TOKEN_OVERRIDES[upper] ?? upper;
}

// Helper function to sort leagues by earliest game start time
function sortLeaguesByGameStartTime(leagueList) {
  if (!leagueList || leagueList.length === 0) return [];

  // Get games from exchange store if available
  const gamesList = games.value || [];
  const now = Date.now();

  // Create a map of league to earliest start time
  const leagueStartTimes = {};

  leagueList.forEach((league) => {
    const leagueUpper = league.toString().toUpperCase();
    const leagueGames = gamesList.filter(
      (game) =>
        game.sport === 'soccer' &&
        game.league &&
        game.league.toUpperCase() === leagueUpper &&
        game.start &&
        new Date(game.start).getTime() > now, // Only future games
    );

    if (leagueGames.length > 0) {
      const earliestStart = Math.min(
        ...leagueGames.map((game) => new Date(game.start).getTime()),
      );
      leagueStartTimes[leagueUpper] = earliestStart;
    } else {
      // If no future games, use a far future date so they appear last
      leagueStartTimes[leagueUpper] = Number.MAX_SAFE_INTEGER;
    }
  });

  // Sort by earliest start time, then alphabetically
  return [...leagueList].sort((a, b) => {
    const aUpper = a.toString().toUpperCase();
    const bUpper = b.toString().toUpperCase();
    const aStart = leagueStartTimes[aUpper] || Number.MAX_SAFE_INTEGER;
    const bStart = leagueStartTimes[bUpper] || Number.MAX_SAFE_INTEGER;

    if (aStart !== bStart) {
      return aStart - bStart;
    }

    // If same start time or no games, sort alphabetically
    return aUpper.localeCompare(bUpper);
  });
}

const filteredLeagues = computed(() => {
  const availableLeagues = leagues.value ? [...leagues.value] : [];
  const selected = props.selectedLeague
    ? props.selectedLeague.toString().toUpperCase()
    : '';

  // Fighting: always show UFC + MVP + BOXING in the league header, regardless of selection.
  // The API typically returns UFC as "UFCMMA" while the route uses "ufc".
  // Each league is only rendered if the API includes it in availableLeagues (i.e. there are games).
  if (props.selectedSport === 'fighting') {
    const fightingOrder = ['UFCMMA', 'DWCS', 'MVP', 'BOXING'];
    const fightingLeagues = fightingOrder
      .map((key) =>
        availableLeagues.find((l) => l?.toString().toUpperCase() === key),
      )
      .filter(Boolean);

    // If the API isn't providing these leagues for some reason, fall back to default behavior.
    if (fightingLeagues.length) {
      return fightingLeagues;
    }
  }

  // Baseball: always show MLB + WBC in the league header, regardless of selection.
  if (props.selectedSport === 'baseball') {
    const baseballOrder = ['MLB', 'MLB-LIVE', 'MLB-PROPS', 'F5-MLB', 'WBC'];
    const baseballLeagues = baseballOrder
      .map((key) =>
        availableLeagues.find((l) => l?.toString().toUpperCase() === key),
      )
      .filter(Boolean);

    if (baseballLeagues.length) {
      return baseballLeagues;
    }
  }

  // Tennis: always show both ATP + WTA in the league header, regardless of selection.
  if (props.selectedSport === 'tennis') {
    const tennisOrder = ['ATP', 'ATP-LIVE', 'WTA', 'WTA-LIVE'];
    const tennisLeagues = tennisOrder
      .map((key) =>
        availableLeagues.find((l) => l?.toString().toUpperCase() === key),
      )
      .filter(Boolean);

    if (tennisLeagues.length) {
      return tennisLeagues;
    }
  }

  // Football: always show every football league so users can hop between
  // NFL preseason and CFL (and the rest) from any football league page.
  // NFL-PRESEASON leads as the headline league, CFL sits right after it,
  // and any league the API adds later is appended untouched.
  if (props.selectedSport === 'football') {
    const footballOrder = [
      'NFL-PRESEASON',
      'CFL',
      'NFL',
      'NCAAF',
      'NCAAF-EXTRAS',
      'UFL',
    ];
    const footballLeagues = footballOrder
      .map((key) =>
        availableLeagues.find((l) => l?.toString().toUpperCase() === key),
      )
      .filter(Boolean);
    const extraFootballLeagues = availableLeagues.filter(
      (l) => !footballOrder.includes(l?.toString().toUpperCase()),
    );

    if (footballLeagues.length) {
      return [...footballLeagues, ...extraFootballLeagues];
    }
  }

  // For soccer, always show all leagues regardless of selection, with "ALL" first
  // and sort the rest by earliest game start time. Live leagues are excluded:
  // they live under the LIVE tab, and the start-time sort would bury them
  // anyway (a live game never has a future start).
  if (props.selectedSport === 'soccer') {
    const allLeague = availableLeagues.find(
      (league) => league?.toString().toUpperCase() === 'ALL',
    );
    const otherLeagues = availableLeagues.filter((league) => {
      const code = league?.toString().toUpperCase();
      return code !== 'ALL' && !isLiveLeagueCode(code);
    });

    // Sort other leagues by earliest game start time
    const sortedOtherLeagues = sortLeaguesByGameStartTime(otherLeagues);

    return allLeague ? [allLeague, ...sortedOtherLeagues] : sortedOtherLeagues;
  }

  if (
    !selected ||
    selected === 'ALL' ||
    selected === 'UPCOMING' ||
    selected === 'CUSTOM'
  ) {
    return sortLeaguesWithPinned(availableLeagues);
  }

  const baseSelected = mapBaseToken(getPrimaryToken(selected));

  const filtered = availableLeagues.filter((league) => {
    const leagueUpper = league?.toString().toUpperCase();
    if (!leagueUpper) return false;
    if (leagueUpper === 'ALL' || leagueUpper === 'UPCOMING') return true;
    if (
      leagueUpper === 'CUSTOM' ||
      leagueUpper === 'CFL' ||
      leagueUpper === 'UFL'
    )
      return true;

    const leagueBase = mapBaseToken(getPrimaryToken(leagueUpper));
    return leagueBase === baseSelected;
  });

  return sortLeaguesWithPinned(filtered);
});

const sortedLeagues = computed(() => {
  // For soccer, filteredLeagues already has the correct sorting (ALL first, rest by game start time)
  // Football is also pre-ordered (NFL-PRESEASON, CFL, then the rest) —
  // re-sorting would pin CFL/UFL to the end of the row.
  if (props.selectedSport === 'soccer' || props.selectedSport === 'football') {
    return filteredLeagues.value;
  }

  let aux = [...filteredLeagues.value];
  if (!aux.length) return [];

  const first = aux.shift();
  const sorted = sortLeaguesWithPinned(aux);
  return [first, ...sorted];
});

// Direct mapping for league codes from the API
// API sends codes with dashes instead of spaces (e.g., "PREMIER-LEAGUE")
const leagueCodeAliases = {
  // England
  'PREMIER-LEAGUE': { country: 'England', continent: 'Europe', name: 'Premier League' },
  'PREMIERLEAGUE': { country: 'England', continent: 'Europe', name: 'Premier League' },
  'ENGLAND-EPL': { country: 'England', continent: 'Europe', name: 'Premier League' },
  'ENGLANDEPL': { country: 'England', continent: 'Europe', name: 'Premier League' },
  'EPL': { country: 'England', continent: 'Europe', name: 'Premier League' },
  'ENGLAND-PREMIER-LEAGUE': { country: 'England', continent: 'Europe', name: 'Premier League' },
  'ENGLANDPREMIERLEAGUE': { country: 'England', continent: 'Europe', name: 'Premier League' },
  'FA-CUP': { country: 'England', continent: 'Europe', name: 'FA Cup' },
  'FACUP': { country: 'England', continent: 'Europe', name: 'FA Cup' },
  'EFL-CUP': { country: 'England', continent: 'Europe', name: 'EFL Cup' },
  'EFLCUP': { country: 'England', continent: 'Europe', name: 'EFL Cup' },
  'ENGLAND-CHAMPIONSHIP': { country: 'England', continent: 'Europe', name: 'England Championship' },
  'ENGLANDCHAMPIONSHIP': { country: 'England', continent: 'Europe', name: 'England Championship' },
  'ENGLAND-LEAGUE-1': { country: 'England', continent: 'Europe', name: 'England League 1' },
  'ENGLANDLEAGUE1': { country: 'England', continent: 'Europe', name: 'England League 1' },
  'ENGLAND-LEAGUE-2': { country: 'England', continent: 'Europe', name: 'England League 2' },
  'ENGLANDLEAGUE2': { country: 'England', continent: 'Europe', name: 'England League 2' },
  'ENGLAND-NATIONAL-LEAGUE': { country: 'England', continent: 'Europe', name: 'England National League' },
  'ENGLANDNATIONALLEAGUE': { country: 'England', continent: 'Europe', name: 'England National League' },
  
  // Spain
  'LA-LIGA': { country: 'Spain', continent: 'Europe', name: 'La Liga' },
  'LALIGA': { country: 'Spain', continent: 'Europe', name: 'La Liga' },
  'LA-LIGA-2': { country: 'Spain', continent: 'Europe', name: 'La Liga 2' },
  'LALIGA2': { country: 'Spain', continent: 'Europe', name: 'La Liga 2' },
  'COPA-DEL-REY': { country: 'Spain', continent: 'Europe', name: 'Copa del Rey' },
  'COPADELREY': { country: 'Spain', continent: 'Europe', name: 'Copa del Rey' },
  
  // Germany
  'BUNDESLIGA': { country: 'Germany', continent: 'Europe', name: 'Bundesliga' },
  '2ND-BUNDESLIGA': { country: 'Germany', continent: 'Europe', name: '2nd Bundesliga' },
  '2NDBUNDESLIGA': { country: 'Germany', continent: 'Europe', name: '2nd Bundesliga' },
  'GERMANY-DFB-POKAL': { country: 'Germany', continent: 'Europe', name: 'Germany DFB Pokal' },
  'GERMANYDFBPOKAL': { country: 'Germany', continent: 'Europe', name: 'Germany DFB Pokal' },
  
  // Italy
  'SERIE-A': { country: 'Italy', continent: 'Europe', name: 'Serie A' },
  'SERIEA': { country: 'Italy', continent: 'Europe', name: 'Serie A' },
  'SERIE-B': { country: 'Italy', continent: 'Europe', name: 'Serie B' },
  'SERIEB': { country: 'Italy', continent: 'Europe', name: 'Serie B' },
  'ITALY-COPPA-ITALIA': { country: 'Italy', continent: 'Europe', name: 'Italy Coppa Italia' },
  'ITALYCOPPAITALIA': { country: 'Italy', continent: 'Europe', name: 'Italy Coppa Italia' },
  
  // France
  'LIGUE-1': { country: 'France', continent: 'Europe', name: 'Ligue 1' },
  'LIGUE1': { country: 'France', continent: 'Europe', name: 'Ligue 1' },
  'LIGUE-2': { country: 'France', continent: 'Europe', name: 'Ligue 2' },
  'LIGUE2': { country: 'France', continent: 'Europe', name: 'Ligue 2' },
  'FRANCE-COUPE-DE-FRANCE': { country: 'France', continent: 'Europe', name: 'France Coupe de France' },
  'FRANCECOUPEDEFRANCE': { country: 'France', continent: 'Europe', name: 'France Coupe de France' },
  
  // Netherlands
  'NETHERLANDS-EREDIVISIE': { country: 'Netherlands', continent: 'Europe', name: 'Netherlands Eredivisie' },
  'NETHERLANDSEREDIVISIE': { country: 'Netherlands', continent: 'Europe', name: 'Netherlands Eredivisie' },
  
  // Belgium
  'BELGIUM-JUPILER-LEAGUE': { country: 'Belgium', continent: 'Europe', name: 'Belgium Jupiler League' },
  'BELGIUMJUPILERLEAGUE': { country: 'Belgium', continent: 'Europe', name: 'Belgium Jupiler League' },
  
  // Scotland
  'SCOTLAND-PREMIER-LEAGUE': { country: 'Scotland', continent: 'Europe', name: 'Scotland Premier League' },
  'SCOTLANDPREMIERLEAGUE': { country: 'Scotland', continent: 'Europe', name: 'Scotland Premier League' },
  
  // Turkey
  'TURKEY-SUPER-LIG': { country: 'Turkey', continent: 'Europe', name: 'Turkey Super Lig' },
  'TURKEYSUPERLIG': { country: 'Turkey', continent: 'Europe', name: 'Turkey Super Lig' },
  
  // Greece
  'GREECE-SUPERLEAGUE': { country: 'Greece', continent: 'Europe', name: 'Greece Superleague' },
  'GREECESUPERLEAGUE': { country: 'Greece', continent: 'Europe', name: 'Greece Superleague' },
  
  // Austria
  'AUSTRIA-BUNDESLIGA': { country: 'Austria', continent: 'Europe', name: 'Austria Bundesliga' },
  'AUSTRIABUNDESLIGA': { country: 'Austria', continent: 'Europe', name: 'Austria Bundesliga' },
  
  // Switzerland
  'SWITZERLAND-SUPER-LEAGUE': { country: 'Switzerland', continent: 'Europe', name: 'Switzerland Super League' },
  'SWITZERLANDSUPERLEAGUE': { country: 'Switzerland', continent: 'Europe', name: 'Switzerland Super League' },
  
  // Denmark
  'DENMARK-SAS-LIGAEN': { country: 'Denmark', continent: 'Europe', name: 'Denmark SAS Ligaen' },
  'DENMARKSASLIGAEN': { country: 'Denmark', continent: 'Europe', name: 'Denmark SAS Ligaen' },
  
  // Poland
  'POLAND-EKSTRAKLASA': { country: 'Poland', continent: 'Europe', name: 'Poland Ekstraklasa' },
  'POLANDEKSTRAKLASA': { country: 'Poland', continent: 'Europe', name: 'Poland Ekstraklasa' },
  
  // Hungary
  'HUNGARY-NB-1': { country: 'Hungary', continent: 'Europe', name: 'Hungary NB 1' },
  'HUNGARYNB1': { country: 'Hungary', continent: 'Europe', name: 'Hungary NB 1' },
  
  // Slovenia
  'SLOVENIA-PRVA-LIGA': { country: 'Slovenia', continent: 'Europe', name: 'Slovenia Prva Liga' },
  'SLOVENIAPRVALIGA': { country: 'Slovenia', continent: 'Europe', name: 'Slovenia Prva Liga' },
  
  // Croatia
  'CROATIA-HNL-LEAGUE-1': { country: 'Croatia', continent: 'Europe', name: 'Croatia HNL League 1' },
  'CROATIAHNLLEAGUE1': { country: 'Croatia', continent: 'Europe', name: 'Croatia HNL League 1' },
  
  // Portugal
  'PORTUGAL-1-LIGA': { country: 'Portugal', continent: 'Europe', name: 'Portugal 1 Liga' },
  'PORTUGAL1LIGA': { country: 'Portugal', continent: 'Europe', name: 'Portugal 1 Liga' },
  
  // Ireland
  'IRELAND-EIRCOM-LEAGUE': { country: 'Ireland', continent: 'Europe', name: 'Ireland Eircom League' },
  'IRELANDEIRCOMLEAGUE': { country: 'Ireland', continent: 'Europe', name: 'Ireland Eircom League' },
  
  // Russia
  'RUSSIAN-PREMIER-LEAGUE': { country: 'Russia', continent: 'Europe', name: 'Russian Premier League' },
  'RUSSIANPREMIERLEAGUE': { country: 'Russia', continent: 'Europe', name: 'Russian Premier League' },
  'RUSSIA-PREMIER-LEAGUE': { country: 'Russia', continent: 'Europe', name: 'Russian Premier League' },
  'RUSSIAPREMIERLEAGUE': { country: 'Russia', continent: 'Europe', name: 'Russian Premier League' },
  'RUSSIA-FNL': { country: 'Russia', continent: 'Europe', name: 'Russia FNL' },
  'RUSSIAFNL': { country: 'Russia', continent: 'Europe', name: 'Russia FNL' },

  // Norway
  'NORWAY-ELITESERIEN': { country: 'Norway', continent: 'Europe', name: 'Norway Eliteserien' },
  'NORWAYELITESERIEN': { country: 'Norway', continent: 'Europe', name: 'Norway Eliteserien' },
  'ELITESERIEN': { country: 'Norway', continent: 'Europe', name: 'Norway Eliteserien' },
  'NORWAY-TIPPELIGAEN': { country: 'Norway', continent: 'Europe', name: 'Norway Tippeligaen' },
  'NORWAYTIPPELIGAEN': { country: 'Norway', continent: 'Europe', name: 'Norway Tippeligaen' },

  // UEFA Competitions
  'CHAMPIONS-LEAGUE': { country: 'Europe', continent: 'Europe', name: 'Champions League' },
  'CHAMPIONSLEAGUE': { country: 'Europe', continent: 'Europe', name: 'Champions League' },
  'EUROPA-LEAGUE': { country: 'Europe', continent: 'Europe', name: 'Europa League' },
  'EUROPALEAGUE': { country: 'Europe', continent: 'Europe', name: 'Europa League' },
  
  // International
  'WORLD-CUP': { country: 'International', continent: 'International', name: 'World Cup' },
  'WORLDCUP': { country: 'International', continent: 'International', name: 'World Cup' },
  'WORLD-CUP-LIVE': { country: 'International', continent: 'International', name: 'World Cup' },
  'WORLDCUPLIVE': { country: 'International', continent: 'International', name: 'World Cup' },
  'WC-QUALIFIERS-EUROPE': { country: 'International', continent: 'International', name: 'WC Qualifiers Europe' },
  'WCQUALIFIERSEUROPE': { country: 'International', continent: 'International', name: 'WC Qualifiers Europe' },
  'SOCCER-WINNER': { country: 'International', continent: 'International', name: 'World Cup Winner' },
  'SOCCERWINNER': { country: 'International', continent: 'International', name: 'World Cup Winner' },
  'TO-ADVANCE': { country: 'International', continent: 'International', name: 'To Advance' },
  'TOADVANCE': { country: 'International', continent: 'International', name: 'To Advance' },
  
  // Mexico
  'LIGA-MX': { country: 'Mexico', continent: 'North America', name: 'Liga MX' },
  'LIGAMX': { country: 'Mexico', continent: 'North America', name: 'Liga MX' },
  'LIGA-EXPANSION-MX': { country: 'Mexico', continent: 'North America', name: 'Liga Expansion MX' },
  'LIGAEXPANSIONMX': { country: 'Mexico', continent: 'North America', name: 'Liga Expansion MX' },
  
  // Canada
  'CANADA-CPL': { country: 'Canada', continent: 'North America', name: 'Canadian Premier League' },
  'CANADACPL': { country: 'Canada', continent: 'North America', name: 'Canadian Premier League' },
  'CANADA-PREMIER-LEAGUE': { country: 'Canada', continent: 'North America', name: 'Canadian Premier League' },
  'CANADAPREMIERLEAGUE': { country: 'Canada', continent: 'North America', name: 'Canadian Premier League' },
  'CANADIAN-PREMIER-LEAGUE': { country: 'Canada', continent: 'North America', name: 'Canadian Premier League' },
  'CANADIANPREMIERLEAGUE': { country: 'Canada', continent: 'North America', name: 'Canadian Premier League' },
  'MLS': { country: 'USA/Canada', continent: 'North America', name: 'MLS' },

  // Costa Rica
  'COSTA-RICA-1ST-DIVISION': { country: 'Costa Rica', continent: 'North America', name: 'Costa Rica 1st Division' },
  'COSTARICA1STDIVISION': { country: 'Costa Rica', continent: 'North America', name: 'Costa Rica 1st Division' },
  
  // South America
  'BRAZIL-SERIE-A': { country: 'Brazil', continent: 'South America', name: 'Brazil Serie A' },
  'BRAZILSERIEA': { country: 'Brazil', continent: 'South America', name: 'Brazil Serie A' },
  'ARGENTINA-PRIMERA-DIVISION': { country: 'Argentina', continent: 'South America', name: 'Argentina Primera Division' },
  'ARGENTINAPRIMERADIVISION': { country: 'Argentina', continent: 'South America', name: 'Argentina Primera Division' },
  'CHILE-PRIMERA-DIVISION': { country: 'Chile', continent: 'South America', name: 'Chile Primera Division' },
  'CHILEPRIMERADIVISION': { country: 'Chile', continent: 'South America', name: 'Chile Primera Division' },
  'URUGUAY-PRIMERA-DIVISION': { country: 'Uruguay', continent: 'South America', name: 'Uruguay Primera Division' },
  'URUGUAYPRIMERADIVISION': { country: 'Uruguay', continent: 'South America', name: 'Uruguay Primera Division' },
  'PERU-PRIMERA-DIVISION': { country: 'Peru', continent: 'South America', name: 'Peru Primera Division' },
  'PERUPRIMERADIVISION': { country: 'Peru', continent: 'South America', name: 'Peru Primera Division' },
  'PARAGUAY-1ER-DIVISION': { country: 'Paraguay', continent: 'South America', name: 'Paraguay 1er Division' },
  'PARAGUAY1ERDIVISION': { country: 'Paraguay', continent: 'South America', name: 'Paraguay 1er Division' },
  'ECUADOR-SERIE-A': { country: 'Ecuador', continent: 'South America', name: 'Ecuador Serie A' },
  'ECUADORSERIEA': { country: 'Ecuador', continent: 'South America', name: 'Ecuador Serie A' },
  'ECUADOR-LIGA-PRO': { country: 'Ecuador', continent: 'South America', name: 'Ecuador LigaPro Serie A' },
  'ECUADORLIGAPRO': { country: 'Ecuador', continent: 'South America', name: 'Ecuador LigaPro Serie A' },
  'ECUADOR-LIGAPRO-SERIE-A': { country: 'Ecuador', continent: 'South America', name: 'Ecuador LigaPro Serie A' },
  'ECUADORLIGAPROSERIEA': { country: 'Ecuador', continent: 'South America', name: 'Ecuador LigaPro Serie A' },
  'COPA-LIBERTADORES': { country: 'South America', continent: 'South America', name: 'Copa Libertadores' },
  'COPALIBERTADORES': { country: 'South America', continent: 'South America', name: 'Copa Libertadores' },
  'COPA-SUDAMERICANA': { country: 'South America', continent: 'South America', name: 'Copa Sudamericana' },
  'COPASUDAMERICANA': { country: 'South America', continent: 'South America', name: 'Copa Sudamericana' },
  
  // Asia
  'JAPAN-J-LEAGUE': { country: 'Japan', continent: 'Asia', name: 'Japan J League' },
  'JAPANJLEAGUE': { country: 'Japan', continent: 'Asia', name: 'Japan J League' },
  'SAUDI-ARABIA-PREMIER-LEAGUE': { country: 'Saudi Arabia', continent: 'Asia', name: 'Saudi Arabia Premier League' },
  'SAUDIARABIAPREMIERLEAGUE': { country: 'Saudi Arabia', continent: 'Asia', name: 'Saudi Arabia Premier League' },
  
  // Special categories
  'FEATURED-SOCCER': { country: null, continent: 'Other', name: 'Featured Soccer' },
  'FEATUREDSOCCER': { country: null, continent: 'Other', name: 'Featured Soccer' },
  'CUSTOM-SOCCER': { country: null, continent: 'Other', name: 'Custom Soccer' },
  'CUSTOMSOCCER': { country: null, continent: 'Other', name: 'Custom Soccer' },
};

// Live markets share their base league's display name (e.g. the live
// "INTERNATIONAL-FRIENDLIES-LIVE" resolves to "Friendlies", same as the
// pre-match "INTERNATIONAL-FRIENDLIES"). Prefix the live one so the two are
// distinguishable in the leagues grid.
function isLiveLeagueCode(code) {
  return /-LIVE$/.test((code ?? '').toString().toUpperCase());
}

function decorateLeagueName(code, baseName) {
  return isLiveLeagueCode(code) ? `Live ${baseName}` : baseName;
}

/**
 * Groups available soccer leagues by continent according to the soccerLeagues constant.
 * Returns an object with continent names as keys and arrays of matching leagues as values.
 * Only includes continents/countries that have matching leagues in the available leagues.
 */
const leaguesGroupedByContinent = computed(() => {
  const availableLeagues = leagues.value ? [...leagues.value] : [];
  if (!availableLeagues.length) return {};

  const grouped = {};

  // Normalize code for matching (remove spaces, hyphens, make uppercase)
  const normalizeCode = (code) => code.toUpperCase().replace(/[\s-]/g, '');

  // Helper to find matching league data from soccerLeagues
  const findLeagueData = (code) => {
    const normalizedCode = normalizeCode(code);
    
    // First check direct aliases
    if (leagueCodeAliases[normalizedCode]) {
      return leagueCodeAliases[normalizedCode];
    }
    
    // Also try with original code (with hyphens)
    const upperCode = code.toUpperCase();
    if (leagueCodeAliases[upperCode]) {
      return leagueCodeAliases[upperCode];
    }

    // Then check soccerLeagues constant
    for (const [continentKey, continent] of Object.entries(soccerLeagues)) {
      // Check continent-level competitions
      if (continent.competitions) {
        const found = continent.competitions.find((l) => {
          const constCode = normalizeCode(l.code);
          // Check both directions for partial match
          return constCode.includes(normalizedCode) || normalizedCode.includes(constCode);
        });
        if (found) return { ...found, continent: continent.name };
      }
      // Check country-level leagues
      if (continent.countries) {
        for (const [countryKey, country] of Object.entries(continent.countries)) {
          if (country.leagues) {
            const found = country.leagues.find((l) => {
              const constCode = normalizeCode(l.code);
              // Check both directions for partial match
              return constCode.includes(normalizedCode) || normalizedCode.includes(constCode);
            });
            if (found) {
              return {
                ...found,
                continent: continent.name,
                country: country.name,
              };
            }
          }
        }
      }
    }
    return null;
  };

  // Process each available league
  for (const league of availableLeagues) {
    const code = league?.toString().toUpperCase();
    if (!code || code === 'ALL') continue;

    // Live leagues get their own group instead of scattering across the
    // continent menus. Displayed under the base league's name; the "Live"
    // group header carries the live-ness.
    if (isLiveLeagueCode(code)) {
      const baseCode = code.replace(/-?LIVE$/, '');
      const baseData = findLeagueData(baseCode);
      if (!grouped['Live']) {
        grouped['Live'] = [];
      }
      grouped['Live'].push({
        code,
        name: baseData?.name || baseCode,
        country: baseData?.country || null,
        original: league,
      });
      continue;
    }

    // Try to find in soccerLeagues constant
    const leagueData = findLeagueData(code);

    if (leagueData) {
      const continentName = leagueData.continent;
      if (!grouped[continentName]) {
        grouped[continentName] = [];
      }
      grouped[continentName].push({
        code: code,
        name: decorateLeagueName(code, leagueData.name),
        country: leagueData.country || null,
        original: league,
      });
    } else {
      // League not found in soccerLeagues, group under "Independent"
      if (!grouped['Other']) {
        grouped['Other'] = [];
      }
      grouped['Other'].push({
        code: code,
        name: decorateLeagueName(code, code),
        country: null,
        original: league,
      });
    }
  }

  // Sort leagues within each continent
  // For Europe, put the top leagues first (exact matches only)
  // Order: Premier League, Bundesliga, La Liga, Serie A, Ligue 1, Champions League, Europa League
  const europeTopLeagues = [
    'PREMIER-LEAGUE',
    'PREMIERLEAGUE',
    'BUNDESLIGA',
    'LA-LIGA',
    'LALIGA',
    'SERIE-A',
    'SERIEA',
    'LIGUE-1',
    'LIGUE1',
    'CHAMPIONS-LEAGUE',
    'CHAMPIONSLEAGUE',
    'UEFA-CHAMPIONS-LEAGUE',
    'UEFACHAMPIONSLEAGUE',
    'EUROPA-LEAGUE',
    'EUROPALEAGUE',
    'UEFA-EUROPA-LEAGUE',
    'UEFAEUROPALEAGUE',
  ];
  
  // Helper function to check if league code exactly matches one of our top leagues
  const isTopLeague = (leagueCode) => {
    const code = leagueCode.toUpperCase();
    return europeTopLeagues.includes(code);
  };
  
  // Helper to get the priority index of a top league
  const getTopLeagueIndex = (leagueCode) => {
    const code = leagueCode.toUpperCase();
    const idx = europeTopLeagues.indexOf(code);
    // Group aliases together (e.g., PREMIER-LEAGUE and PREMIERLEAGUE both get index 0)
    if (idx <= 1) return 0; // Premier League
    if (idx <= 4) return 1; // Bundesliga, La Liga
    if (idx <= 6) return 2; // Serie A
    if (idx <= 8) return 3; // Ligue 1
    if (idx <= 11) return 4; // Champions League
    if (idx <= 15) return 5; // Europa League
    return 999;
  };
  
  for (const continent of Object.keys(grouped)) {
    if (continent === 'Europe') {
      grouped[continent].sort((a, b) => {
        const aIsTop = isTopLeague(a.code);
        const bIsTop = isTopLeague(b.code);
        
        // Top leagues come first
        if (aIsTop && !bIsTop) return -1;
        if (!aIsTop && bIsTop) return 1;
        
        // Within top leagues, maintain specific order
        if (aIsTop && bIsTop) {
          return getTopLeagueIndex(a.code) - getTopLeagueIndex(b.code);
        }
        
        // Otherwise sort alphabetically
        return a.name.localeCompare(b.name);
      });
    } else {
      grouped[continent].sort((a, b) => a.name.localeCompare(b.name));
    }
  }

  return grouped;
});

/**
 * Returns the list of continents that have available leagues, in a preferred display order.
 */
const availableContinents = computed(() => {
  const grouped = leaguesGroupedByContinent.value;
  const preferredOrder = [
    'Live',
    'Europe',
    'International',
    'South America',
    'North America',
    'Asia',
    'Africa',
    'Oceania',
    'Other',
  ];

  return preferredOrder.filter((continent) => grouped[continent]?.length > 0);
});

const routeName = computed(() => {
  if (userStore.user.sportsbookDefault) return 'GamesPage';
  return 'Exchange';
});

const unreadCount = computed(() => numUnread.value || 0);

function handleNotificationBellClick() {
  const rect = notificationBellRef.value?.getBoundingClientRect();
  emitter.emit('openNotificationInbox', {
    toggle: true,
    fromAlert: false,
    rect: rect
      ? {
          top: rect.top,
          right: rect.right,
          bottom: rect.bottom,
          left: rect.left,
          width: rect.width,
          height: rect.height,
        }
      : null,
  });
}

// Focus the pill input as soon as it exists, retrying briefly so a focus fired
// before the input finishes mounting (slide-out transition / async row render)
// still lands instead of being a single no-op.
function focusMobileSearch() {
  let tries = 0;
  const tryFocus = () => {
    const el = searchInputRef.value;
    if (el) {
      el.focus();
      if (document.activeElement === el) return;
    }
    if (tries++ < 20) {
      setTimeout(tryFocus, 50);
    }
  };
  nextTick(tryFocus);
}

function toggleSearchPopup() {
  showSearchPopup.value = !showSearchPopup.value;
  if (showSearchPopup.value) {
    userSettingPopUp.value = false;
    focusMobileSearch();
  }
}

// Opened from the mobile bottom-bar search option. Slides the pill search
// bar out along the league/bell/filter row and focuses the input, exactly
// like the 4cx mobile search.
function openMobileSearch() {
  showSearchPopup.value = true;
  userSettingPopUp.value = false;
  focusMobileSearch();
}

function closeMobileSearch() {
  showSearchPopup.value = false;
}

// Keep the bottom bar's Search "box" in sync with the pill across every
// open/close path. Reset on unmount so the box doesn't stay lit if we navigate
// away (e.g. tapping a search result) with the pill still open.
watch(showSearchPopup, (open) => setMobileSearchOpen(open));
onBeforeUnmount(() => setMobileSearchOpen(false));

// Consume a pending mobile-search request and open the pill. `immediate`
// catches a request made while this header was still loading. Skipped in
// homeMode so the homepage's own filter-row pill handles it (avoids two
// pills opening at once).
watch(
  mobileSearchRequest,
  () => {
    if (!props.homeMode && consumeMobileSearch()) {
      openMobileSearch();
    }
  },
  { immediate: true },
);

function convert1H(league) {
  if (league.toLowerCase().includes('1h')) {
    if (league === '1H NFL') {
      return '1H NFL';
    } else if (league === '1H NCAAF') {
      return '1H NCAAF';
    } else if (league === '1H NCAAB') {
      return '1H NCAAB';
    }
    return '1ST HALF';
  }
  return league;
}

function formatGolfLeagueName(league, sport) {
  if (sport === 'golf') {
    // Normalize the league name for comparison (remove extra spaces, convert to uppercase)
    const normalized = league
      .toUpperCase()
      .replace(/\s+/g, ' ')
      .replace(/-/g, ' ')
      .trim();
    // Round matchups: "ROUND-1-FED-EX-500", "ROUND 2 FED EX 500", etc.
    if (/ROUND/.test(normalized) && /FED\s*EX\s*500|FEDEX\s*500/.test(normalized)) {
      return 'ROUND MATCHUPS';
    }
    // Tournament matchups: "FED-EX-500", "FED EX 500", etc. (no "ROUND")
    if (/FED\s*EX\s*500|FEDEX\s*500/.test(normalized)) {
      return 'TOURNAMENT MATCHUPS';
    }
  }
  return league;
}

function hyphenateUrlParams(string) {
  return string.replaceAll('-', ' ');
}

function emitSearch() {
  emit('searchForEvent', search.value);
  showSearchPopup.value = false;
}

function toggleLeaguesMenu() {
  leaguesMenu.value = !leaguesMenu.value;
  if (leaguesMenu.value && leaguesMenuButtonRef.value) {
    nextTick(() => {
      const rect = leaguesMenuButtonRef.value.getBoundingClientRect();
      popupPosition.value = {
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX,
      };
    });
  }
}

const popupStyle = computed(() => {
  if (!leaguesMenu.value || !leaguesMenuButtonRef.value) {
    return {};
  }
  return {
    position: 'fixed',
    top: `${popupPosition.value.top}px`,
    left: `${popupPosition.value.left}px`,
  };
});

function clickListener() {
  userSettingPopUp.value = false;
  leaguesMenu.value = false;
  showSearchPopup.value = false;
}

// Mobile: close the settings dropdown when the user scrolls. Capture phase
// because scroll events don't bubble — it's the only way to hear scrolls
// from inner scrollables (league tab strip, game lists), not just the page.
// Page scrolls only count after real distance: on the homepage this bar
// appears mid-scroll, and the momentum/settle events still firing right
// after the opening tap would otherwise close the popup before it's seen.
const SCROLL_CLOSE_THRESHOLD = 30;
let settingPopUpScrollY = 0;

watch(userSettingPopUp, (open) => {
  if (open) {
    settingPopUpScrollY = window.scrollY;
  }
});

function scrollCloseListener(event) {
  if (!isMobile.value || !userSettingPopUp.value) return;
  const isPageScroll =
    event.target === document ||
    event.target === document.documentElement ||
    event.target === document.body;
  if (
    isPageScroll &&
    Math.abs(window.scrollY - settingPopUpScrollY) < SCROLL_CLOSE_THRESHOLD
  ) {
    return;
  }
  userSettingPopUp.value = false;
}

function handleScroll() {
  if (!headerRef.value) return;
  // Home mode renders a fixed overlay (offsetTop is meaningless there), so use
  // a small fixed threshold to slide the sports nav in once the user scrolls
  // past the home filter bar.
  const offset = props.homeMode
    ? 80
    : (stickyOffset.value ?? headerRef.value.offsetTop ?? 0);
  let nextSticky = window.scrollY > offset;
  // Mobile home: this bar is the only path to the bell and settings (the
  // filter row is desktop-only and the section headers carry no controls).
  // If the page is too short to ever scroll past the threshold (empty or
  // thin sections), keep the bar shown instead of unreachable.
  if (props.homeMode && isMobile.value && !nextSticky) {
    const maxScroll =
      document.documentElement.scrollHeight - window.innerHeight;
    nextSticky = maxScroll <= offset;
  }
  if (nextSticky !== isSticky.value) {
    isSticky.value = nextSticky;
  }
  if (isSticky.value) {
    leaguesMenu.value = false;
  }
}

function isSportActive(sport) {
  if (sport.id === 'all-props') {
    return allPropsRouteNames.includes(route.name);
  }

  const currentSport =
    (route.params?.sport ?? props.selectedSport)?.toLowerCase() ?? '';
  const currentLeague =
    (route.params?.league ?? props.selectedLeague)?.toLowerCase() ?? '';

  if (!currentSport) {
    return false;
  }

  if (currentSport !== sport.sport) {
    return false;
  }

  if (sport.leagues?.length) {
    if (!currentLeague) return false;
    return sport.leagues.includes(currentLeague);
  }

  return true;
}

function handleSportNavigate(sport, navigate, event) {
  if (sport.disabled) {
    event.preventDefault();
    return;
  }

  if (sport.id === 'all-props') {
    navigate(event);
    return;
  }

  const currentSport =
    (route.params?.sport ?? props.selectedSport)?.toLowerCase() ?? '';
  const currentLeague =
    (route.params?.league ?? props.selectedLeague)?.toLowerCase() ?? '';

  const matchesSport = sport.sport === currentSport;
  const matchesLeague = sport.leagues?.length
    ? sport.leagues.includes(currentLeague)
    : true;

  if (matchesSport && matchesLeague) {
    exchangeStore.getSportsData(sport.sport);
    emitter.emit('disableError', { error: false });
  }

  navigate(event);
}

function handleCancelAllHotkey(event) {
  const tag = event.target?.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || event.target?.isContentEditable) return;
  if (event.shiftKey && (event.key === 'Delete' || event.key === 'Backspace')) {
    event.preventDefault();
    cancelAll();
  }
}

// Recompute the scroll fades whenever the row's content or sticky state can
// change its scroll width (league list swap, sport/league change, sticky
// nav swap). nextTick so we measure after the DOM updates.
watch(
  [filteredLeagues, isSticky, () => props.selectedSport, () => props.selectedLeague],
  () => nextTick(updateScrollFades),
);

onMounted(() => {
  window.addEventListener('click', clickListener);
  // In home mode the home view owns the cancel-all hotkey; registering it here
  // too would fire cancel-all twice on a single keypress (duplicate dialogs and
  // requests), so only the non-home header binds it.
  if (!props.homeMode) {
    window.addEventListener('keydown', handleCancelAllHotkey);
  }
  stickyOffset.value = headerRef.value?.offsetTop ?? 0;
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('scroll', scrollCloseListener, {
    capture: true,
    passive: true,
  });
  window.addEventListener('resize', updateScrollFades);
  // Resize/rotation changes the scrollable height that decides whether the
  // home bar must stay pinned on short pages — re-evaluate along with fades.
  window.addEventListener('resize', handleScroll);
  handleScroll();
  nextTick(updateScrollFades);
});

onBeforeUnmount(() => {
  window.removeEventListener('click', clickListener);
  if (!props.homeMode) {
    window.removeEventListener('keydown', handleCancelAllHotkey);
  }
  window.removeEventListener('scroll', handleScroll);
  window.removeEventListener('scroll', scrollCloseListener, { capture: true });
  window.removeEventListener('resize', updateScrollFades);
  window.removeEventListener('resize', handleScroll);
});

// Cancel all offers functionality
const { request: cancelAllRequest } = useAPI('/session/cancelAllOrders');
const { request: cancelAllForLeagueRequest } = useAPI(
  '/session/cancelAllForLeague',
);
const { request: cancelAllForGameRequest } = useAPI(
  '/session/cancelAllOrdersForGame',
);

async function cancelAll() {
  // ✅ Check authentication first
  if (!checkAuthAndShowLogin()) {
    return;
  }
  // Snapshot the route the dialog is opened for. The user can navigate while
  // the modal is open; reading route.* again in the confirm branch would scope
  // the cancel to wherever they ended up, not the game/league they saw.
  const isSingleGame = route.name === 'SingleGameMarket';
  const scopedGameID = route.params.gameID;
  const scopedLeague = route.params.league;
  const scopedSport = route.params.sport;

  let showScopedCancel = false;
  let confirmText;
  if (isSingleGame && scopedGameID) {
    showScopedCancel = true;
    confirmText = 'Cancel This Game';
  } else if (
    scopedLeague &&
    scopedLeague !== 'all' &&
    scopedLeague !== 'upcoming'
  ) {
    showScopedCancel = true;
    confirmText = `Cancel ${scopedLeague.toUpperCase()}`;
  }

  const result = await Swal.fire({
    html: '<h4>Cancel Offers?</h4>',
    showCancelButton: true,
    showDenyButton: true,
    allowEnterKey: false,
    showConfirmButton: showScopedCancel,
    confirmButtonText: confirmText,
    denyButtonText: 'Cancel all',
    cancelButtonText: "Don't Cancel",
    confirmButtonColor: 'primary',
    denyButtonColor: '#6f75b1',
  });

  if (result.isConfirmed || result.isDenied) {
    loading.value = true;
    if (result.isDenied) {
      try {
        const response = await cancelAllRequest();
        loading.value = false;
        emitter.emit('showAlert', {
          type: 'canceled-order',
          shown: true,
          status: response.length > 0 ? 'ok' : 'warning',
          title:
            response.length > 0 ? 'All Orders Cancelled' : 'No Open Orders',
          detail: '',
        });
      } catch (error) {
        loading.value = false;
        emitter.emit('showAlert', {
          shown: true,
          status: 'danger',
          title: 'Orders not cancelled',
          detail: 'error cancelling orders',
        });
      }
    } else if (result.isConfirmed) {
      try {
        if (isSingleGame) {
          await cancelAllForGameRequest({ gameID: scopedGameID });
        } else {
          let params;
          if (scopedSport === 'fighting') {
            const league =
              scopedLeague === 'ufc' ? 'UFCMMA' : scopedLeague.toUpperCase();
            params = {
              league: league,
            };
          } else {
            params = {
              league: scopedLeague.toUpperCase(),
            };
          }
          cancelAllForLeagueRequest(params);
        }
        loading.value = false;
        emitter.emit('showAlert', {
          type: 'canceled-order',
          shown: true,
          status: 'ok',
          title: 'Cancel Orders Received',
          detail: '',
        });
      } catch (error) {
        loading.value = false;
        emitter.emit('showAlert', {
          shown: true,
          type: 'warn',
          title: 'Orders not cancelled',
          detail: '',
        });
      }
    }
    Swal.fire('Confirmed!', 'Your orders are being cancelled.', 'success');
  }
}

function openContinentMenu(continent) {
  if (selectedContinent.value === continent) {
    isOpenContinentMenu.value = !isOpenContinentMenu.value;
  } else {
    selectedContinent.value = continent;
    isOpenContinentMenu.value = true;
  }
}

const countryFlags = {
  'England': '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  'Spain': '🇪🇸',
  'Germany': '🇩🇪',
  'Italy': '🇮🇹',
  'France': '🇫🇷',
  'Portugal': '🇵🇹',
  'Netherlands': '🇳🇱',
  'Belgium': '🇧🇪',
  'Scotland': '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  'Ireland': '🇮🇪',
  'Turkey': '🇹🇷',
  'Russia': '🇷🇺',
  'Ukraine': '🇺🇦',
  'Poland': '🇵🇱',
  'Greece': '🇬🇷',
  'Switzerland': '🇨🇭',
  'Austria': '🇦🇹',
  'Denmark': '🇩🇰',
  'Sweden': '🇸🇪',
  'Norway': '🇳🇴',
  'Croatia': '🇭🇷',
  'Serbia': '🇷🇸',
  'Czech Republic': '🇨🇿',
  'Romania': '🇷🇴',
  'Hungary': '🇭🇺',
  'Bulgaria': '🇧🇬',
  'Cyprus': '🇨🇾',
  'Slovenia': '🇸🇮',
  'Slovakia': '🇸🇰',
  'Finland': '🇫🇮',
  'Iceland': '🇮🇸',
  'Wales': '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
  'Northern Ireland': '🇬🇧',
  'United States': '🇺🇸',
  'Mexico': '🇲🇽',
  'Canada': '🇨🇦',
  'Brazil': '🇧🇷',
  'Argentina': '🇦🇷',
  'Colombia': '🇨🇴',
  'Chile': '🇨🇱',
  'Peru': '🇵🇪',
  'Ecuador': '🇪🇨',
  'Uruguay': '🇺🇾',
  'Paraguay': '🇵🇾',
  'Venezuela': '🇻🇪',
  'Bolivia': '🇧🇴',
  'Japan': '🇯🇵',
  'South Korea': '🇰🇷',
  'China': '🇨🇳',
  'Australia': '🇦🇺',
  'Saudi Arabia': '🇸🇦',
  'UAE': '🇦🇪',
  'Qatar': '🇶🇦',
  'India': '🇮🇳',
  'Thailand': '🇹🇭',
  'Indonesia': '🇮🇩',
  'Malaysia': '🇲🇾',
  'South Africa': '🇿🇦',
  'Egypt': '🇪🇬',
  'Morocco': '🇲🇦',
  'Tunisia': '🇹🇳',
  'Algeria': '🇩🇿',
  'Nigeria': '🇳🇬',
  'Ghana': '🇬🇭',
  'Kenya': '🇰🇪',
  'New Zealand': '🇳🇿',
  // International/Continental competitions
  'Europe': '🇪🇺',
  'International': '🌍',
  'World': '🌍',
  'UEFA': '🇪🇺',
  'FIFA': '🌍',
  'CONMEBOL': '🌎',
  'CONCACAF': '🌎',
  'AFC': '🌏',
  'CAF': '🌍',
};

function getCountryFlag(country, leagueName = '') {
  // If country is provided, use it
  if (country && countryFlags[country]) {
    return countryFlags[country];
  }
  
  // Check league name for continental competitions
  const nameUpper = leagueName.toUpperCase();
  if (nameUpper.includes('UEFA') || nameUpper.includes('EURO') || nameUpper.includes('EUROPA') || nameUpper.includes('CHAMPIONS LEAGUE')) {
    return '🇪🇺';
  }
  if (nameUpper.includes('COPA') || nameUpper.includes('CONMEBOL') || nameUpper.includes('LIBERTADORES') || nameUpper.includes('SUDAMERICANA')) {
    return '🌎';
  }
  if (nameUpper.includes('CONCACAF') || nameUpper.includes('LEAGUES CUP') || nameUpper.includes('GOLD CUP')) {
    return '🌎';
  }
  if (nameUpper.includes('AFC') || nameUpper.includes('ASIAN')) {
    return '🌏';
  }
  if (nameUpper.includes('CAF') || nameUpper.includes('AFRICA')) {
    return '🌍';
  }
  if (nameUpper.includes('WORLD CUP') || nameUpper.includes('FIFA') || nameUpper.includes('OLYMPIC')) {
    return '🌍';
  }
  if (nameUpper.includes('WC QUALIFIERS')) {
    return '🌍';
  }
  
  return '⚽';
}
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/tokens.scss' as main;

.headerBackground {
  position: sticky;
  top: 0;
  z-index: 15;
  transition:
    background-color 0.28s ease,
    box-shadow 0.28s ease,
    border-color 0.28s ease;
  // Light mode: solid background (no backdrop-filter for scroll performance)
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  // Night mode: dark background matching content area
  [theme='night'] & {
    background-color: main.$transparent_04;
    box-shadow: 0 2px 4px 0 main.$blue-1200;
  }

  &.header-sticky {
    box-shadow: 0 4px 16px rgba(18, 24, 77, 0.25);
    background-color: main.$color-primary;
    border-bottom: 1px solid rgba(150, 156, 203, 0.18);
    animation: sportsbook-header-slide-in 0.28s ease both;
  }

  // Home page: render the sticky sport nav as a fixed overlay that slides in
  // from the top once the user scrolls. Fixed positioning keeps it out of the
  // layout flow so the home filter bar never shifts (no jump), and the
  // transform/opacity transition makes the entrance/exit smooth.
  &.header-home {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin-bottom: 0;
    background-color: main.$color-primary;
    box-shadow: 0 4px 16px rgba(18, 24, 77, 0.25);
    border-bottom: 1px solid rgba(150, 156, 203, 0.18);
    transform: translateY(-100%);
    opacity: 0;
    pointer-events: none;
    transition: transform 0.28s ease, opacity 0.28s ease;
    will-change: transform, opacity;
  }

  &.header-home--visible {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }

  @media (prefers-reduced-motion: reduce) {
    &.header-sticky {
      animation: none;
    }

    &.header-home {
      transition: opacity 0.2s ease;
    }
  }
}

// The scrolled-in header states paint a $color-primary (navy) bar, and the
// bell's has-unread icon color is ALSO $color-primary — so the bell vanishes
// into the bar while its white unread dot keeps floating on its own. Force
// the icon white on the navy bar states.
.headerBackground.header-sticky :deep(.notification-bell--has-notifications .notification-bell__icon),
.headerBackground.header-home :deep(.notification-bell--has-notifications .notification-bell__icon) {
  color: #ffffff;
}

// Opacity-only fade: the sticky header uses `position: sticky`, and parking a
// `transform` on it (via animation-fill-mode: both) can break pinning in some
// browsers. Fading avoids leaving any transform on the sticky node.
@keyframes sportsbook-header-slide-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

button.indicationBets {
  padding: 2px 1rem;
  border: 1px solid transparent;
  border-radius: 20px;
  background-color: transparent;
  color: var(--black-102);
  opacity: 0.5;
  transition: all 0.2s ease;
}

@media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
  button.indicationBets {
    padding: 2px 10px;
  }
}

.overflow-box {
  max-width: 100%;
  overflow-x: scroll;
}

.indication {
  display: inline-block;
  width: 100%;
  color: main.$color-primary;
  font-weight: main.$font-weight-bold;
  background: none;
  border-radius: 0px;
  cursor: pointer;
}

@media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
  .indication {
    border-radius: 6px;
    padding: 0.5rem;
    border: 1px solid main.$color-primary;
  }
}

.indication-league.router-link-active {
  border-bottom: 4px solid main.$color-primary;
}

.indication-league:hover {
  border-bottom: 4px solid main.$blue-1100;
}

.indication-fourcaster.router-link-active {
  border-bottom: 4px solid main.$blue-100;
}

.indication-fourcaster:hover {
  border-bottom: 4px solid main.$blue-100;
}

.indication-sportsbook {
  background: main.$green-402;
}

.indication-sportsbook:hover {
  background: main.$green-401;
  cursor: pointer;
}

.font-awesome-large {
  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    display: none;
  }
}

.input {
  background-color: main.$blue-901_02;
  width: 100%;
  height: 90%;
  border-radius: 10px;
}

.input input {
  background: main.$transparent_01 !important;
  padding: 5px 5px 5px 5px;
  color: main.$white;
  width: 100%;
}

.input input:focus {
  border-bottom-color: main.$transparent;
  border-bottom: 1px solid main.$white;
  border-radius: 0;
}

.input input::placeholder {
  color: main.$white;
  font-style: italic;
  font-weight: lighter;
}

.eye {
  position: absolute;
  width: 18px;
  color: main.$grey-1800;
  top: 9px;
}

.indicationBets {
  font-size: 0.7rem;
  display: inline-block;
  width: 100%;
  color: var(--black-102);
  font-weight: main.$font-weight-bold;
  transition: all 0.2s ease;
  background: none;
  border-radius: 0px;
  cursor: pointer;
}

@media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
  .indicationBets {
    font-size: main.$font-size-xs;
    padding: 0.4rem;
  }
}

.indicationBets-league:hover {
  color: var(--black-102);
  text-decoration: none;
  opacity: 0.8;
  background-color: var(--grey-1600);
}

.indicationBets-league.router-link-active {
  color: var(--black-102);
  text-decoration: none;
  opacity: 1;
  background-color: var(--white_02-1);
  border-color: var(--grey-1200-1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-weight: main.$font-weight-bold;
}

.indicationBets-fourcaster:hover {
  color: var(--black-102);
  text-decoration: none;
  opacity: 0.8;
  background-color: var(--grey-1600);
}

.indicationBets-fourcaster.router-link-active {
  color: var(--black-102);
  text-decoration: none;
  opacity: 1;
  background-color: var(--white_02-1);
  border-color: var(--grey-1200-1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-weight: main.$font-weight-bold;
}

.indicationBets-create {
  opacity: 0.7;
  background-color: rgba(99, 102, 241, 0.15);
  border: 1px dashed var(--color-primary_05);
  color: var(--color-primary_05);
  transition: all 0.2s ease;
  
  &:hover {
    opacity: 1;
    background-color: var(--color-primary_05);
    color: white;
    border-style: solid;
  }
}

.indicationBets-sportsbook {
  background: main.$green-402;
}

.indicationBets-sportsbook:hover {
  background: main.$green-401;
  cursor: pointer;
}

@media (max-width: 1280px) {
  .overflow-events {
    overflow-x: auto;
    overflow-y: hidden;
  }
}

.overflow-length {
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0;
  margin-top: -1px;
  padding: 2px;

  // Width of the soft edge fade. The mask makes the row's own pixels
  // transparent at the fading edge, so the header background (white in light
  // mode, dark in night, purple in the home bar) shows through — no
  // hard-coded colour needed and it stays correct across themes.
  --edge-fade: 28px;

  // Hide the league tabs while the search pill is pulled out over the row.
  &--search-open {
    visibility: hidden;
  }

  // More content off the right edge.
  &--fade-end {
    -webkit-mask-image: linear-gradient(
      to right,
      #000 calc(100% - var(--edge-fade)),
      transparent 100%
    );
    mask-image: linear-gradient(
      to right,
      #000 calc(100% - var(--edge-fade)),
      transparent 100%
    );
  }

  // More content off the left edge (scrolled in a bit).
  &--fade-start {
    -webkit-mask-image: linear-gradient(
      to right,
      transparent 0,
      #000 var(--edge-fade)
    );
    mask-image: linear-gradient(
      to right,
      transparent 0,
      #000 var(--edge-fade)
    );
  }

  // Off both edges: fade both sides.
  &--fade-start#{&}--fade-end {
    -webkit-mask-image: linear-gradient(
      to right,
      transparent 0,
      #000 var(--edge-fade),
      #000 calc(100% - var(--edge-fade)),
      transparent 100%
    );
    mask-image: linear-gradient(
      to right,
      transparent 0,
      #000 var(--edge-fade),
      #000 calc(100% - var(--edge-fade)),
      transparent 100%
    );
  }
}

// Hide the bell + filter icons while the search pill is open so nothing
// shows through the transparent pill (matches the 4cx mobile behavior).
.mini--search-open {
  visibility: hidden;
}

// 4cx-style pill search bar that slides out along the header row when the
// mobile bottom-bar search is tapped. The parent `.leagueHeader` is
// position:relative so this absolutely-positioned pill spans the whole row
// where the league tabs + bell + filter icons sit.
.mobile-search-bar {
  position: absolute;
  top: 4px;
  bottom: 4px;
  // Negative insets pull the pill out past the .container side padding so it
  // runs nearly edge-to-edge, matching the homepage search pill length.
  left: -11px;
  right: -11px;
  z-index: 25;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 16px;
  background: transparent;
  border: 1px solid rgba(150, 156, 203, 0.45);
  border-radius: 999px;
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease;

  // Blue outline on focus so the user's eye lands where they're typing.
  &:focus-within {
    border-color: #969ccb;
  }

  &__icon {
    font-size: 1rem;
    color: #969ccb;
    flex-shrink: 0;
  }

  &__input {
    flex: 1;
    min-width: 0;
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    border: 0 !important;
    border-radius: 0 !important;
    outline: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    appearance: none;
    -webkit-appearance: none;
    font-family: inherit;
    // 16px min keeps iOS from zooming the viewport when the pill is focused.
    font-size: 16px;
    font-weight: normal !important;
    line-height: 1.3;
    color: main.$color-primary;

    // On the dark (night) theme the pill is transparent over a dark row,
    // so typed text needs to be light.
    [theme='night'] & {
      color: #fff;
    }

    &:focus,
    &:focus-visible,
    &:hover,
    &:active {
      outline: 0 !important;
      box-shadow: none !important;
      background: transparent !important;
      border: 0 !important;
    }

    &::placeholder {
      color: rgba(150, 156, 203, 0.85);
      font-weight: normal;
    }
  }
}

// Slide-in animation for the expanding bar.
.mobile-search-expand-enter-active {
  transition:
    clip-path 0.22s ease,
    opacity 0.18s ease;
  transform-origin: right center;
}

.mobile-search-expand-enter-from {
  clip-path: inset(0 0 0 100%);
  opacity: 0;
}

.mobile-search-expand-enter-to {
  clip-path: inset(0 0 0 0);
  opacity: 1;
}

// Close instantly: animating the leave would briefly show the hidden header
// row under the fading pill (a flash). Snap it shut instead.
.mobile-search-expand-leave-active {
  transition: none;
}

.mobile-search-expand-leave-to {
  opacity: 0;
}

.overflow-length::-webkit-scrollbar {
  height: 7px;
  width: 7px;
  background: main.$color-primary;
}

.overflow-length::-webkit-scrollbar-thumb:horizontal {
  background: main.$grey-2501;
  border-radius: 10px;
  border-style: solid;
  border-width: thin;
  border-color: main.$color-primary;
}

.singleHeader {
  line-height: 4;
  font-size: 11.2px;
  cursor: pointer;
  text-decoration: none;
}

@media (min-width: 768px) {
  .movil-container {
    padding: 0;
  }
}

@media (max-width: 769px) {
  .movil-container {
    height: 40px;
  }
}

@media (max-width: 769px) {
  .overflow-length::-webkit-scrollbar {
    height: 5px;
    width: 5px;
    background: main.$color-primary;
  }
}

.header-width {
  min-width: max-content;
  align-content: center;
  @media screen and (min-width: 1280px) {
    padding: 0;
  }
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    padding-left: 0;
  }
}

.leagueHeader {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  min-height: 36px;
  position: relative;
}

.sticky-nav-scroller {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 4px 0;
  width: 100%;
  align-items: center;
  scroll-padding: 12px;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(150, 156, 203, 0.35);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  // Mobile scrolls by touch and the edge fade already signals overflow —
  // the scrollbar under the strip is just noise there.
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.sticky-sport-btn {
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 11px;
  color: #969ccb;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.9rem;
  font-weight: main.$font-weight-normal;
  gap: 8px;
  padding: 6px 10px;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
  white-space: nowrap;
  position: relative;

  &::after {
    content: none;
  }

  &:hover {
    color: main.$white;
  }

  // Same rounded "you are here" box as the bottom mobile menu — the strip
  // always sits on the purple sticky/home bar, so the white-alpha box works
  // in both themes.
  &.active {
    color: main.$white;
    background-color: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.12);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    font-size: 0.8rem;
    padding: 5px 8px;
    gap: 5px;
  }

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    font-size: 0.7rem;
    padding: 4px 6px;
    gap: 4px;
  }
}

.sticky-sport-icon {
  align-items: center;
  display: flex;
  justify-content: center;
  line-height: 1;
  opacity: 0.9;

  &__glyph {
    font-size: 1em;
    color: inherit;
  }
}

::global([theme='night']) .headerBackground .sticky-sport-btn {
  color: rgba(215, 219, 255, 0.7);
}

::global([theme='night']) .headerBackground .sticky-sport-btn:hover {
  color: main.$white;
}

::global([theme='night']) .headerBackground .sticky-sport-btn.active {
  color: main.$white;
}

::global([theme='night']) .headerBackground.header-sticky {
  background: main.$color-primary;
  border-bottom: 1px solid rgba(134, 144, 219, 0.25);
}

.sticky-sport-text {
  font-size: inherit;
  line-height: 1;

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    line-height: 1.1;
  }
}

// Anchored to `.mini` so the dropdown's right edge lines up with the
// filter icon at every breakpoint.
.popup {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  width: 300px;
  background: main.$white_01;
  border: 1px solid var(--grey-1200-1);
  box-shadow: 0 2px 10px main.$black-101;
  padding: 0.5rem 0;
  border-radius: 10px;
  color: main.$grey-2300;
  z-index: 2;
}


.account-logo .filter-icon {
  color: #969ccb;
  font-size: 20px;
  // Padding + negative margin: the pressed pill extends around the glyph
  // without moving it, so the popup stays flush with the icon's right edge.
  padding: 4px;
  margin: -4px;
  border-radius: 6px;
  transition:
    color 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    color: #343b86;
  }

  // Pressed state while the settings dropdown is open — clears when the
  // dropdown closes (second tap, outside tap, or scroll).
  &--active {
    color: #343b86;
    background-color: rgba(150, 156, 203, 0.25);
  }
}

[theme='night'] .account-logo .filter-icon:hover {
  color: #ffffff;
}

// The purple home-mode bar needs the light-on-dark pressed state in both
// themes; night mode uses it everywhere.
[theme='night'] .account-logo .filter-icon--active,
.header-home .account-logo .filter-icon--active {
  color: #ffffff;
  background-color: rgba(198, 205, 235, 0.22);
}

.notification-search-trigger {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  transition: opacity 0.2s ease;

  &__icon {
    font-size: 1.05rem;
    color: #969ccb;
  }

  &--active {
    opacity: 1;
  }

  &:hover {
    cursor: pointer;
    opacity: 1;
  }

  &:hover .notification-search-trigger__icon {
    color: #343b86;
  }

  @media screen and (min-width: map.get(main.$grid-breakpoints, md)) {
    margin: 0;
  }
}

[theme='night'] .notification-search-trigger:hover .notification-search-trigger__icon {
  color: #ffffff;
}

.content-account-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  & > .notification-bell,
  & > .notification-search-trigger,
  & > .account-logo {
    margin: 0 !important;
  }

  @media screen and (min-width: map.get(main.$grid-breakpoints, md)) {
    gap: 1.5rem;
  }
}

.content-account-info .account-logo {
  margin-left: 0 !important;
}

.notification-search {
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  width: min(240px, 75vw);
  background: main.$white;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  box-shadow: main.$box-shadow-03;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 20;

  &__input {
    width: 100%;
    border: none;
    outline: none;
    font-size: 0.9rem;
    color: main.$color-primary;
  }

  @media screen and (min-width: map.get(main.$grid-breakpoints, md)) {
    width: min(280px, 70vw);
  }

  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    left: auto;
    right: 0;
    transform: none;
  }
}

// Horizontal pullout search bar that slides out leftward from the magnifier
// icon when it's clicked on desktop / tablet (ported from 4cx). Only on the
// sport-page league header — the homepage keeps the drop-down above, and
// mobile uses the full-row `.mobile-search-bar` expansion.
.league-search-pullout {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 25;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 281px;
  padding: 5px 20px;
  background: main.$white_02;
  border: 1.5px solid rgba(150, 156, 203, 0.55);
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease;

  &:focus-within {
    border-color: #969ccb;
    box-shadow: 0 2px 12px rgba(150, 156, 203, 0.25);
  }

  @media screen and (max-width: map.get(main.$grid-breakpoints, lg)) {
    width: 191px;
  }

  &__icon {
    font-size: 1.05rem;
    color: #969ccb;
    flex-shrink: 0;
  }

  &__input {
    flex: 1;
    min-width: 0;
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    border: 0 !important;
    border-radius: 0 !important;
    outline: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    appearance: none;
    -webkit-appearance: none;
    font-family: inherit;
    font-size: 0.95rem;
    font-weight: normal !important;
    line-height: 1.15;
    color: main.$color-primary_01;

    &:focus,
    &:focus-visible,
    &:hover,
    &:active {
      outline: 0 !important;
      box-shadow: none !important;
      background: transparent !important;
      border: 0 !important;
    }

    &::placeholder {
      color: rgba(150, 156, 203, 0.85);
      font-weight: normal;
    }
  }
}

// Slide the pullout open/closed from the magnifier's edge (clip-path so the
// pill uncovers leftward instead of scaling).
.league-search-expand-enter-active,
.league-search-expand-leave-active {
  transition:
    clip-path 0.22s ease,
    opacity 0.18s ease;
  transform-origin: right center;
}

.league-search-expand-enter-from,
.league-search-expand-leave-to {
  transform: translateY(-50%);
  clip-path: inset(0 0 0 100%);
  opacity: 0;
}

.league-search-expand-enter-to,
.league-search-expand-leave-from {
  transform: translateY(-50%);
  clip-path: inset(0 0 0 0);
  opacity: 1;
}

.info-tooltip {
  width: 0 !important;
  padding-left: 0 !important;
  padding-bottom: 0 !important;
}

.div-input {
  padding-top: 0 !important;
  margin-top: 0;
}

.mini {
  // Positioning anchor for the settings dropdown (.popup) — its right
  // content edge is flush with the filter icon.
  position: relative;
  padding-right: 0px;
  padding-left: 10px;
}

@media screen and (max-width: 375px) {
  .mini {
    padding-right: 0px;
    padding-left: 10px;
  }
}

.createGame {
  cursor: pointer;
  font-weight: 700;
  margin-bottom: 3px;
  background-color: main.$color-primary_06;
  margin-left: 2px;
  color: main.$color-primary_09;
}

@media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
  .createGame {
    margin-left: 8px;
    height: 35px;
    padding: 5px;
  }
}

.createGame:hover {
  color: main.$white;
  text-decoration: none;
  transform: scale(1.025);
  transition: transform 0.3s;
}

.createGameDiv {
  align-self: center;
  padding: inherit;
}

.custom-header {
  min-inline-size: max-content;
}

.leagues-menu {
  font-size: 0.7rem;
  display: inline-block;
  width: 100%;
  color: main.$grey-300_01;
  font-weight: main.$font-weight-bold;
  padding: 4px 1rem;
  cursor: pointer;
  background-color: main.$color-primary_10;
  border-style: solid main.$color-primary_10;
  border-radius: 20px;
}

@media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
  .leagues-menu {
    padding: 4px 1rem;
    font-size: 0.75rem;
    line-height: 20px;
  }
}

.leagues-menu:hover {
  color: main.$white;
  text-decoration: none;
  background-color: main.$color-primary_05;
}

.leagues-menu-item {
  color: main.$color-primary_01;
  background-color: main.$transparent_01;
  width: 100%;
  border-radius: 0px;
  font-size: 10px;
}

.leagues-menu-item:hover {
  background-color: main.$grey-300;
}

.leagues-popup {
  position: fixed;
  background-color: main.$white_01;
  -webkit-box-shadow: 0 2px 10px main.$black-101;
  box-shadow: main.$box-shadow-03;
  border-radius: 5px;
  z-index: 1000;
  width: max-content;
  min-width: 400px;
  max-width: 90vw;
}

@media screen and (max-width: 990px) {
  .leagues-popup {
    min-width: 350px;
  }
}

@media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
  .leagues-popup {
    width: 80%;
    min-width: 300px;
    max-width: 85vw;
  }
}

@media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
  .leagues-popup {
    width: 90%;
    min-width: 250px;
    max-width: 90vw;
  }
}

@media screen and (max-width: 460px) {
  .leagues-popup {
    width: 95%;
    min-width: 200px;
    max-width: 95vw;
  }
}

@media (max-width: 1280px) {
  .overflow-events {
    overflow-x: auto;
    overflow-y: hidden;
  }
}


.dropdown {
  width: 100%;
  background: var(--background-01);
  background-position-x: 300px;
  background-size: 12px;
  border: 1px solid var(--color-primary_05);
}

.dropdown-button{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

// Soccer Leagues Dropdown Styles
.soccer-leagues-dropdown {
  padding: 1rem;
  width: 100%;

  // Light mode: always use a light background so league names stay readable
  [theme='day'] & {
    background: main.$white_01;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }
  
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    max-height: 65vh;
    overflow-y: auto;
    padding: 0.5rem;
    background: var(--color-primary);
    border-radius: 8px;
    margin-bottom: 1rem;

  }
}

.soccer-leagues-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.25rem 0.75rem 0.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 0.5rem;
  position: sticky;
  top: 0;
  background: var(--color-primary);
  z-index: 1;

  [theme='day'] & {
    border-bottom-color: rgba(0, 0, 0, 0.08);
    background: main.$white_01;
  }
}

.soccer-leagues-title {
  font-weight: 600;
  color: main.$white;
  font-size: 14px;

  [theme='day'] .soccer-leagues-header & {
    color: main.$color-primary_01;
  }
}

.soccer-leagues-close {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  
  &:hover {
    color: main.$white;
  }

  [theme='day'] .soccer-leagues-header & {
    color: main.$grey-2300;

    &:hover {
      color: main.$color-primary_01;
    }
  }
}

.soccer-leagues-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
  
  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    grid-template-columns: 1fr;
  }
}

.soccer-league-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: rgba(99, 102, 241, 0.1);
  border: 1px solid transparent;
  border-radius: 8px;
  color: var(--white);
  text-decoration: none;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:hover {
    background-color: rgba(99, 102, 241, 0.25);
    border-color: rgba(99, 102, 241, 0.4);
    transform: translateY(-1px);
  }
  
  &--active {
    background-color: main.$color-primary;
    border-color: main.$color-primary;
    
    &:hover {
      background-color: main.$color-primary;
    }
  }
  
  [theme='day'] & {
    color: main.$color-primary_01;
    background-color: rgba(99, 102, 241, 0.08);
    
    &:hover {
      background-color: rgba(99, 102, 241, 0.15);
    }
    
    &--active {
      background-color: main.$color-primary;
      color: main.$white;
    }
  }
}

.soccer-league-flag {
  font-size: 1.1rem;
  flex-shrink: 0;
}

.soccer-league-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

// Legacy dropdown styles (keep for other uses)
.dropdown-content {
  width: 100%;
}

.dropdown-content-item {
  border-style: solid var(--color-primary_10);
  border-radius: 20px;
  background-color: var(--color-primary_10);
  color: var(--white);
  margin-right: 3px;

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    margin-right: 3px !important;
    margin-bottom: 3px !important;
  }
}

.dropdown-content a {
  color: var(--white) !important;
  padding: 0px 10px;
  text-decoration: none;
  display: block;
  text-align: left;
  color: var(--color-primary_01);
  display: inline-flex;
}

.dropdown-content a:hover {background-color: var(--color-primary_05);}

hr {
  display: block;
  height: 1px;
  border: 0;
  margin: 1em 0;
  padding: 0;
  background: var(--gradient-003);
}

.sub-league-container {
  padding: 0 1rem;
  max-width: 1400px;
  margin: 0 auto;

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    padding: 0 0.75rem;
  }
}

</style>
